module.exports = __webpack_public_path__ + "img/21_64.1c887530.png";